// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nG0Gg","title":"styles_title__1v2v8"};